import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=f4bbc550&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"
import style0 from "./Inquiry.vue?vue&type=style&index=0&id=f4bbc550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bbc550",
  null
  
)

export default component.exports